import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function CategoryNav() {
  return (
    <section className="w-full px-4 md:px-6 -mt-12 relative z-10">
      <div className="max-w-4xl mx-auto">
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 md:p-6 bg-background-50 rounded-xl hover:bg-background-100 border border-background-200/70 transition-all cursor-pointer"
            >
              <span className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-background-50 transition-all">
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </span>
              <span className="text-sm md:text-base font-semibold text-foreground-800 group-hover:text-foreground-950 font-heading whitespace-nowrap">
                {cat.label}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}